import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledHyperstarFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M7.246.496c.83 0 1.568.093 2.224.259a7 7 0 0 1-.746.58L6.977 2.5l1.747 1.165a8.1 8.1 0 0 1 2.111 2.111L12 7.523l1.165-1.747c.163-.244.355-.49.565-.73.182.71.266 1.455.266 2.201 0 1.6-.38 3.201-1.318 4.442l2.822 2.82-.99.991-2.816-2.815c-1.045.81-2.496 1.312-4.448 1.312-5.062 0-6.75-3.375-6.75-6.75S2.184.497 7.246.497"
                        fill="currentColor"
                    />
                    <path
                        d="M12 0a9.5 9.5 0 0 0 2.5 2.5A9.5 9.5 0 0 0 12 5a9.5 9.5 0 0 0-2.5-2.5A9.5 9.5 0 0 0 12 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierFilledHyperstarFilledSize16Glyph.displayName = 'MagnifierFilledHyperstarFilledSize16Glyph';
